import { handleActions } from 'redux-actions'

import * as rawActions from '../../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.showPdfSearchResults](state, action) {
      return true
    },
    [rawActions.hidePdfSearchResults](state, action) {
      return defaultState
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
